module.exports = __webpack_public_path__ + "static/img/money@2x.27e60b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money@2x.png
// module id = qC79
// module chunks = 0